export default {
  imageWrapper: {
    overflowX: ['auto', 'auto', 'auto', 'auto', 'hidden'],
    width: '100%',
    height: '100%',
    bg: 'transparent',
    border: 'none',
    margin: ['0 auto', '0 auto', '0 auto', '0 auto', 0],
    display: 'block'
  },
  singleImageBox: {
    width: '100%',
    height: '100%',
    position: 'relative',
    display: 'block',
    border: 'none',
    margin: ['0 auto', '0 auto', '0 auto', '0 auto', 0]
  },
  imageStyle: {
    position: ['static !important', 'static !important', 'absolute !important'],
    objectFit: 'cover',
    width: '100%',
    height: ['auto', 'auto', '100%']
  }
};